import React, { useEffect, useState } from 'react';
import Wrapper from './styles';
import { loadHotEvents } from '../../../microservices/sbgate';
import { getRoute, isActiveRoute } from '../../../services/router';
import { stores } from '../../../stores';
import UiButton from '../../ui/button/UiButton';
import UiNavLink from '../../ui/nav-link/UiNavLink';
import classNames from 'classnames';
import { translate } from '../../../services/translate';
import { TAG_MANAGER_EVENT, trackGoogleTagManagerEvent } from '../../../services/analytics';
import UiTag from '../../ui/tag/UiTag';
import { FoHotEvent } from '@staycool/sbgate-types';
import SportCategoryIcon from '../category-icon/SportCategoryIcon';
import isEmpty from 'lodash/isEmpty';
import { useStore } from '../../../hooks/useStore';
import { isFeatureAvailable } from '../../../services/feature';
import { FEATURE } from '../../../services/types';
import SportMenuLabelV2 from '../menu-label-v-2/SportMenuLabelV2';

interface Props {
    type?: string;
    wrap?: boolean;
    isTwoToneTheme?: boolean;
}

export default function SportHotEvents({ type, wrap, isTwoToneTheme }: Props) {
    const [hotEvents] = useStore(stores.sports.hotEvents);
    const [isMenuVisible, setIsMenuVisible] = useState(true);
    const hotEventsOrPlaceholders = hotEvents || ([{}, {}, {}, {}, {}] as FoHotEvent[]);
    const isMainNavigationV2 = isFeatureAvailable(FEATURE.SPORT_MAIN_NAVIGATION_V2);
    const label = translate('Hot Events', 'ui.sportsbook');

    useEffect(() => {
        loadHotEvents();
    }, []);

    function hotEventClicked() {
        trackGoogleTagManagerEvent(TAG_MANAGER_EVENT.SPORT_HOT_EVENT_CLICKED);
        stores.sports.isSportSideMenuOpen.set(false);
    }

    function getUrl(event: FoHotEvent) {
        if (event.match_id) {
            return `${getRoute('sport')}/match/${event.match_id}`;
        }
        return `${getRoute('sport')}/${event.slug}`;
    }

    if (hotEvents && !hotEvents.length) {
        return null;
    }
    if (type === 'menu') {
        return (
            <Wrapper $type={type}>
                {isMainNavigationV2 ? (
                    <SportMenuLabelV2 isMenuVisible={isMenuVisible} onDrawerClick={setIsMenuVisible}>
                        {label}
                    </SportMenuLabelV2>
                ) : (
                    <div className="menu-label">{label}</div>
                )}
                <div className={classNames('hot-events-list', { ['hot-events-list-hidden']: !isMenuVisible })}>
                    {hotEventsOrPlaceholders.map((event, index) => (
                        <UiButton
                            className={classNames({ placeholder: isEmpty(event) })}
                            url={getUrl(event)}
                            type="menu"
                            isTwoToneTheme={isTwoToneTheme}
                            size="default"
                            key={event.slug || index}
                            onClick={hotEventClicked}
                            icon={<SportCategoryIcon icon={event.sport_icon} fallbackIcon={event.league_icon} />}
                        >
                            {event.display_name}
                        </UiButton>
                    ))}
                </div>
            </Wrapper>
        );
    } else {
        return (
            <Wrapper>
                {wrap && <div className="menu-label">{label}</div>}

                <div
                    className={classNames('tabs-list', {
                        wrap: wrap,
                    })}
                >
                    {hotEventsOrPlaceholders.map((event, index) => (
                        <UiNavLink to={getUrl(event)} key={event.slug || index} onClick={hotEventClicked}>
                            <UiTag
                                selected={isActiveRoute(`${getRoute('sport')}/${event.slug}`, false)}
                                icon={<SportCategoryIcon icon={event.sport_icon} fallbackIcon={event.league_icon} />}
                            >
                                {event.display_name}
                            </UiTag>
                        </UiNavLink>
                    ))}
                </div>
            </Wrapper>
        );
    }
}
